import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Placeholder that matches the size/shape of a single data card. */
const CardSkeleton = () => (
  <Card sx={{ minHeight: 200, height: '100%' }}>
    <Stack spacing={2} height="100%">
      <Skeleton variant="text" width="40%" height={28} />
      <Skeleton variant="rectangular" sx={{ flexGrow: 1, borderRadius: 1 }} />
      <Skeleton variant="rounded" height={40} />
    </Stack>
  </Card>
);

/**
 * Loading state for the AI Tooling data cards – keeps the two-card layout
 * stable while the credit balance and API keys are being fetched.
 */
const AiToolingCardsSkeleton = () => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    spacing={2}
    data-testid="ai-tooling-loading"
  >
    <Box flex={1}>
      <CardSkeleton />
    </Box>
    <Box flex={1}>
      <CardSkeleton />
    </Box>
  </Stack>
);

export default AiToolingCardsSkeleton;
